/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UserLocation,
    UserLocationFromJSON,
    UserLocationFromJSONTyped,
    UserLocationToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserLocationDataFrame
 */
export interface UserLocationDataFrame {
    /**
     * 
     * @type {number}
     * @memberof UserLocationDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof UserLocationDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof UserLocationDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<UserLocation>}
     * @memberof UserLocationDataFrame
     */
    data: Array<UserLocation>;
}

export function UserLocationDataFrameFromJSON(json: any): UserLocationDataFrame {
    return UserLocationDataFrameFromJSONTyped(json, false);
}

export function UserLocationDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLocationDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(UserLocationFromJSON)),
    };
}

export function UserLocationDataFrameToJSON(value?: UserLocationDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(UserLocationToJSON)),
    };
}


